<template>
  <kst-section items-mode>
    <StockSearchListPcs sell-price hpp-per-pcs
      @init="handleStock_init"
      @submit="handleStock_submit"
    />

    <template #top-right>
      <template v-if="userData.WarehouseID !== null">
        <kst-button action-mode
          class="is-primary"
          :label="Model.HppAdjItem.Module.FullName"
          :moduleType="Model.HppAdjItem.ModuleType.New"
          @click="handleAdd_item"
        />
      </template>
    </template>

    <template #bottom>
      <template v-if="userItems.length > 0">
        <template v-if="userData.WarehouseID !== null">
          <kst-button action-mode
            class="is-primary"
            :label="Model.HppAdjItem.Module.FullName"
            :moduleType="Model.HppAdjItem.ModuleType.New"
            @click="handleAdd_item"
          />
        </template>
      </template>
    </template>

    <template v-if="userData.WarehouseID !== null">
      <List :userItems="userItems"/>
    </template>
  </kst-section>
</template>

<script>
import Model from "../HpadModel.js";
import Services from "../../../services/Api/HppAdjServices.js";

import List from "./HpadN_Items_List.vue";
import StockSearchListPcs from "../../Stock/SearchListPcs/StkScLPcs.vue";

export default {
  components: {
    List,
    StockSearchListPcs
  },
  props: {
    userData: Object,
    userItems: Array
  },
  data: () => ({
    Model: Model,
    // func
    showStockFunc: null
  }),
  methods: {
    /*** by stock modal ***/

    handleStock_init(show) {
      this.showStockFunc = show;
    },
    handleStock_submit(stockData) {
      let item = Model.createItem();
      Model.New.setItemByStock(item, stockData);
      Model.updateItem(item);
      this.userItems.push(item);
    },

    /*** custom ***/

    handleAdd_item() {
      this.showStockFunc(
        this.userData.WarehouseID,
        Services.getRelatedStockList
      );
    }
  }
}
</script>